import { addingDayWork } from "./date";

export function getStatusInfo(project: any): any {
  const PRIORITY = {
    HIGH: 1,
    LOW: 2,
    NONE: 3,
    FINISHED: 4,
  };

  const checkForcedStep = (toCheck: any[]) => {
    if (toCheck) {
      if (toCheck.length === 0) {
        return false;
      } else {
        return toCheck.some((elem) => elem.isPending === true);
      }
    }
    return false;
  };
  project._viewInfo = {};

  const hasUnreadMessageUser =
    "isChatActive" in project && project.isChatActive;

  const forcedStep = checkForcedStep(project.forcedStep);
  if (forcedStep) {
    project._viewInfo.priority = PRIORITY.HIGH;
    project._viewInfo.header = "Faltou dados";
    project._viewInfo.text = "Para prosseguir, precisamos de mais informações.";
  } else if (project.status === "submitted") {
    const dueDate = addingDayWork(project.logDates.submitted.date, 1);
    project._viewInfo.priority = PRIORITY.NONE;
    project._viewInfo.header = "Em análise";
    project._viewInfo.text =
      "Seu envio de dados foi recebido. Analisaremos para verificar as informações necessárias e em breve aprovaremos.";
    project._viewInfo.dueDate = dueDate;
  } else if (project.status === "approved") {
    const dueDate = addingDayWork(project.logDates.approved.date, 5);
    project._viewInfo.priority = PRIORITY.NONE;
    project._viewInfo.header = "Em produção";
    project._viewInfo.text =
      "Seus dados foram aprovados, em breve você receberá sua proposta inicial.";
    project._viewInfo.dueDate = dueDate;
  } else if (Math.max(...project.completedSteps) < 7) {
    project._viewInfo.priority = PRIORITY.HIGH;
    project._viewInfo.header = "Inicie seu projeto";
    project._viewInfo.text = "Acesse seu projeto e preencha o passo a passo";
  } else if (
    ["first_review", "preview", "second_review"].find(
      (x) => x === project.status
    )
  ) {
    if (hasUnreadMessageUser) {
      project._viewInfo.priority = PRIORITY.NONE;
      project._viewInfo.header = "Chat";
      project._viewInfo.text =
        "Recebemos sua mensagem no chat, em breve responderemos.";
    } else {
      const dueDate = addingDayWork(
        project.logDates.extend_review_automation?.date ||
          project.logDates[project.status].date,
        20
      );
      const reviewNames = {
        preview: {
          name: "Proposta inicial",
          text: "Seu projeto está pronto, acesse para visualizar e pedir revisão.",
        },
        first_review: {
          name: "Revisão 01",
          text: "Sua primeira revisão está pronta, acesse para visualizar e pedir revisão.",
        },
        second_review: {
          name: "Revisão 02",
          text: "Sua revisão final está pronta, acesse para visualizar, tirar suas dúvidas e escolher sua proposta.",
        },
      } as any;
      const review = reviewNames[project.status];

      project._viewInfo.header = review.name;
      if (new Date().getTime() > dueDate.getTime()) {
        project._viewInfo.priority = PRIORITY.HIGH;
        project._viewInfo.text = "Últimos dias para solicitar sua revisão";
      } else {
        project._viewInfo.priority = PRIORITY.LOW;
        project._viewInfo.text = review.text;
      }

      project._viewInfo.dueDate = dueDate;
    }
  } else if (project.status === "waiting_user_feedback") {
    project._viewInfo.priority = PRIORITY.HIGH;
    project._viewInfo.header = "Chat";
    project._viewInfo.text =
      "Temos uma mensagem para você aguardando sua resposta.";
  } else if (project.status === "waiting_confirm_review") {
    project._viewInfo.priority = PRIORITY.NONE;
    project._viewInfo.text =
      "Sua solicitação de revisão foi recebida. Analisaremos as informações necessárias e em breve aprovaremos.";

    project._viewInfo.header = "Em análise";
    project._viewInfo.dueDate = addingDayWork(
      project.logDates.waiting_confirm_review.date,
      1
    );
  } else if (project.status === "waiting_render_approved") {
    project._viewInfo.priority = PRIORITY.NONE;
    project._viewInfo.header = "Em produção";
    project._viewInfo.text =
      "Sua aprovação de projeto foi recebida, em breve você receberá seu caderno final.";
    project._viewInfo.dueDate = addingDayWork(
      project.logDates.waiting_render_approved.date,
      3
    );
  } else if (project.status === "customer-reproved") {
    project._viewInfo.priority = PRIORITY.NONE;
    project._viewInfo.header = "Em produção";
    project._viewInfo.text =
      "Sua solicitação de revisão foi aprovada, em breve você receberá sua revisão.";
    project._viewInfo.dueDate = addingDayWork(
      project.logDates.customer_reproved.date,
      3
    );
  } else if (
    project.status === "reviewing_quality" ||
    project.status === "waiting_quality"
  ) {
    const dueDate = addingDayWork(project.logDates.approved.date, 5);
    project._viewInfo.priority = PRIORITY.NONE;
    project._viewInfo.header = "Em produção";
    project._viewInfo.text =
      "Você deve estar curioso para ver seu novo ambiente! Em breve estará disponível na plataforma após a análise de qualidade.";
    project._viewInfo.dueDate = dueDate;
  } else if (project.status === "final_project") {
    project._viewInfo.priority = PRIORITY.FINISHED;
    project._viewInfo.header = "Projeto finalizado";
    project._viewInfo.text = "Acesse seu projeto";
  } else {
    project._viewInfo.priority = PRIORITY.NONE;
    project._viewInfo.header = "Em produção";
    project._viewInfo.text = "";
  }
  return project;
}
